import type { Transform } from "~/lib/types";
import type { NodeDefinition } from "~/nodes/types";

// Data keys keep their original spaces so old saved graphs still load.
const AXES = [
  { key: "rot X", label: "Rot X" },
  { key: "rot Y", label: "Rot Y" },
  { key: "rot Z", label: "Rot Z" },
] as const;

export const transformNode: NodeDefinition = {
  type: "transform",
  label: "Transform",
  category: "Style",
  inputs: AXES.map((axis) => ({
    key: axis.key,
    label: axis.label,
    socket: "number" as const,
    control: {
      kind: "number" as const,
      key: axis.key,
      label: axis.label,
      step: 0.1,
    },
  })),
  outputs: [{ key: "transform", label: "Transform", socket: "transform" }],
  controls: [],
  defaults: { "rot X": 0, "rot Y": 0, "rot Z": 0 },

  compute(ctx) {
    const transform: Transform = {
      rotation: [
        ctx.number("rot X", 0),
        ctx.number("rot Y", 0),
        ctx.number("rot Z", 0),
      ],
    };

    return { transform };
  },
};
